import { ModuleID } from '../types'
import { IVideosModule } from './types'

let moduleLoaded = false
const VideosModule: IVideosModule = {
  get id() {
    return ModuleID.VIDEOS
  },
  config(_props) {
    return VideosModule
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(VideosModule)
  },
  get loaded() {
    return moduleLoaded
  }
}

export default VideosModule
